import { FC, MouseEvent } from 'react';
import Prev from './components/prev/prev';
import Next from './components/next/next';
import Last from './components/last/last';
import First from './components/first/first';
import Input from './components/input/input';
import { IPagination } from '../../table.types';
import './pagination.scss';

export interface IPaginationProps extends IPagination {
    totalResultsTitle: string;
}

const Pagination: FC<IPaginationProps> = ({ onSetPage, page, total, perPage, totalResultsTitle }) => {
    const totalPages = Math.ceil(total / perPage);
    if (totalPages < 1) {
        return null;
    }

    const onNextHandler = (e: MouseEvent<HTMLElement>) => {
        onSetPage(page + 1)
    }

    const onLastHandler = (e: MouseEvent<HTMLElement>) => {
        onSetPage(totalPages);
    }

    const onPrevHandler = (e: MouseEvent<HTMLElement>) => {
        onSetPage(page - 1);
    }

    const onFirstHandler = (e: MouseEvent<HTMLElement>) => {
        onSetPage(1);
    }

    return (
        <div className="pagination-wrapper">
            <div className="results-wrapper">
                {total} {totalResultsTitle}
            </div>
            <div className="pagination" role="navigation">
                <First
                    isActive={page > 1}
                    onClick={onFirstHandler}
                />
                <Prev
                    isActive={page > 1}
                    onClick={onPrevHandler}
                />
                <div className='page-indicator'>
                    <span>Page</span>
                    <Input
                        page={page}
                        totalPages={totalPages}
                        onSetPage={onSetPage}
                    /> / {totalPages}
                </div>
                <Next
                    isActive={page < totalPages}
                    onClick={onNextHandler}
                />
                <Last
                    isActive={page < totalPages}
                    onClick={onLastHandler}
                />
            </div>
        </div>
    );
}

export default Pagination;
